// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonGroup--root--3hwRx","center-mobile":"ButtonGroup--center-mobile--C79kU"};